import { render, staticRenderFns } from "./close-btn.vue?vue&type=template&id=5c87c1e0&scoped=true"
import script from "./close-btn.vue?vue&type=script&lang=js"
export * from "./close-btn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c87c1e0",
  null
  
)

export default component.exports